import loadable from '@loadable/component';

import { useSurveyByName } from '@Queries/Survey';

import type { CatalogUsageDefinedData, ProductInfoDefinedData, SurveyName } from '@Types/Survey';
import type { SurveyProps } from './typings';

const ProductInfoSurvey = loadable(() => import('./variants/ProductInfoSurvey'));
const CatalogUsageSurvey = loadable(() => import('./variants/CatalogUsageSurvey'));

const SurveyProvider = <T extends SurveyName>(props: SurveyProps<T>) => {
  const { name, data, ...restProps } = props;
  const { survey } = useSurveyByName(name);

  if (!survey) return;

  switch (name) {
    case 'productInfo':
      return <ProductInfoSurvey {...restProps} data={data as ProductInfoDefinedData} />;
    case 'catalogUsage':
      return <CatalogUsageSurvey {...restProps} data={data as CatalogUsageDefinedData} />;
    default:
      const never: never = name;

      return never;
  }
};

export default SurveyProvider;
